<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2023-02-02 17:08:39
 * @LastEditors: PF
 * @LastEditTime: 2023-02-20 11:06:20
 * @FilePath: \VUE3\src\pages\caiwu\views\gongzi\gongzibiao\generate.vue
-->
<template>
  <div>
    <el-dialog class="w600 h430" :model-value="opengenerate" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">生成工资表</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('opengenerate', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="生成年月" prop="gzny" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.gzny" type="month" format="YYYY-MM" value-format="YYYY-MM"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="指定教职工" prop="gzny" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <!-- <el-button type="primary" @click="openJiaoZhiGongDuoTiao=true;row=duoTiao">选择教职工</el-button> -->
              <el-dropdown class="ml10">
            <el-button class="w200" type="primary">
              <el-icon class="el-icon--left">
                <DocumentCopy />
              </el-icon>{{jzgdata.length>0?'指定教职工':'全部教职工'}}<el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu class="w200">
                <el-dropdown-item @click="jzgdata=[]">全部教职工</el-dropdown-item>
                <el-dropdown-item @click="openJiaoZhiGongDuoTiao=true">选择教职工</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="tab" v-for="(item,index) in jzgdata" :key="item.id">
            <el-tag  size="large"  closable @close="guanbi(index)">{{item.xm}}</el-tag>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('opengenerate', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <jiaozhigongduotiao v-if="openJiaoZhiGongDuoTiao" v-model:openDuoTiao="openJiaoZhiGongDuoTiao" :row="{ids:jzgdata}" @ReturnData="duoTiaoReturnData" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect } from '@/api/common.js'
import jiaozhigongduotiao from '@/components/chazhaodaihui/jiaozhigongduotiao.vue'
const props = defineProps({ opengenerate: { type: Boolean, required: true } })
const emits = defineEmits(['update:opengenerate', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const openJiaoZhiGongDuoTiao = ref(false)
const jzgdata = ref([])
const duoTiaoReturnData = (item) => {
  
  jzgdata.value = item
}
const guanbi = (ind) => {
  jzgdata.value.splice(ind, 1)
}
// 提交
const submit = async () => {
  const ids = jzgdata.value.map(item => {
    return item.id
  })
  ruleForm.value.jzgids = ids
  submitForm({
    url: '/api/v2/caiwu/jiaozhigonggongzibiao/shengcheng',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      jzgdata.value = []
      closeWindow('opengenerate', emits, true)
    }
  })
}
// // 获取当前年月
const huoqvdangqiannianyve = () => {
  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  ruleForm.value.gzny = `${year}-0${month}`
}
// bindTable()
huoqvdangqiannianyve()
</script>
<style scoped>
.tab{
  padding-top: 10px;
}
</style>
